import { type ReportedTimings } from '@atlassian/ufo-experimental/types';

export { SUBSCRIBE_ALL, UFOGlobalEventStreamEventType } from '@atlassian/ufo-experimental/types';

export type {
	CustomData,
	UFOGlobalEventStreamExperiencePayload,
	UFOGlobalEventStreamEvent,
	UFOGlobalEventStreamSubscribe,
	SubscribeCallback,
	UFOGlobalEventStreamUnsubscribe,
	ExperienceMetrics,
	ExperienceData,
	PageLoadExperienceData,
} from '@atlassian/ufo-experimental/types';

export enum TenantType {
	RealUser = 'real-user',
	Synthetic = 'synthetic',
}

export type AppConfig = {
	framework?: { name: string; version: string };
	version: { web: string; ssr?: string };
};

type MappedPerformanceMark = { type: 'start' | 'end'; name: string };

type MapPerformanceMark = (mark: string) => MappedPerformanceMark | null;

export type BundleEvalTimingsConfig = {
	mapPerformanceMark: MapPerformanceMark;
	additionalTimings?: (startTime: number) => ReportedTimings;
};

export type ResourceEntry = {
	name: string;
	initiatorType: string;
	// Safari returns undefined https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/transferSize
	transferSize: number | void;
	startTime: number;
	duration: number;
	responseStart: number;
	fetchStart: number;
	workerStart: number;
};

export type ResourceTimingsConfig = {
	sanitiseEndpoints: (url: string) => string | null;
	mapResources: (url: string) => string | null;
	xhrFilter?: (url: string) => boolean;
	hasTimingHeaders?: (url: string) => boolean;
};
